<div class="flex flex-col items-center">
  <div
    class="relative w-full select-none overflow-hidden rounded-xl"
    [class.cursor-grab]="!dragging"
    [class.cursor-grabbing]="dragging"
    (touchstart)="onStart($event)"
    (mousedown)="onStart($event)">
    <div class="flex transition-transform duration-500 ease-in-out" [style.transform]="'translateX(-' + activeIndex * 100 + '%)'">
      @for (image of images; track image) {
        <img [src]="image" alt="project-image" class="w-full flex-shrink-0 object-cover" draggable="false" />
      }
    </div>
  </div>

  <div class="mt-4 flex gap-2">
    @for (image of images; track image; let i = $index) {
      <button
        (click)="setActiveIndex(i)"
        class="h-3 w-3 rounded-full"
        [class.bg-primary]="activeIndex === i"
        [class.bg-gray-400]="activeIndex !== i"></button>
    }
  </div>
</div>
